import React from 'react';

interface InclusionBadgeProps {
  isIncluded: boolean;
  variant?: 'short' | 'long'; // Deprecated: use includedText/notIncludedText to control copy
  includedText?: string;
  notIncludedText?: string;
  size?: 'sm' | 'md';
  className?: string;
}

const InclusionBadge: React.FC<InclusionBadgeProps> = ({
  isIncluded,
  variant = 'short',
  includedText,
  notIncludedText,
  size = 'sm',
  className = '',
}) => {
  const iconSize = size === 'sm' ? 16 : 20;
  const textSize = size === 'sm' ? 'text-[12px]' : 'text-[14px]';
  const gap = size === 'sm' ? 'gap-2' : 'gap-2.5';

  const defaultTexts = {
    short: {
      included: 'Included',
      notIncluded: 'Optional',
    },
    long: {
      included: 'Included in the Package',
      notIncluded: 'chargeable at the site',
    },
  } as const;

  const includedCopy = includedText ?? defaultTexts[variant].included;
  const notIncludedCopy = notIncludedText ?? defaultTexts[variant].notIncluded;
  const text = isIncluded ? includedCopy : notIncludedCopy;

  return (
    <div className={`flex items-center ${gap} ${className}`}>
      {isIncluded ? (
        <>
          <div className='w-4 h-4 flex-shrink-0'>
            <svg
              width={iconSize}
              height={iconSize}
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle cx='8' cy='8' r='8' fill='#34A853' />
              <path
                d='M5 8L7 10L11 6'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <span className={`${textSize} font-normal text-green-600`}>
            {text}
          </span>
        </>
      ) : (
        <>
          <div className='w-4 h-4 flex-shrink-0'>
            <svg
              width={iconSize}
              height={iconSize}
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle cx='8' cy='8' r='8' fill='#FFA500' />
              <text
                x='8'
                y='12'
                fontSize='12'
                fontWeight='bold'
                textAnchor='middle'
                fill='white'
              >
                i
              </text>
            </svg>
          </div>
          <span
            className={`${textSize} font-normal`}
            style={{ color: '#FF8C00' }}
          >
            {text}
          </span>
        </>
      )}
    </div>
  );
};

export default InclusionBadge;
